// extracted by mini-css-extract-plugin
export default {"social_links":"SocialLinks_social_links__g-wqk","link":"SocialLinks_link__d0E1g"};